import type { ReactElement } from "react";
import type { CKFilterContextProps } from "./CKFilterContext";
import { useCKFilterContext } from "./CKFilterContext";

export interface CKFilterSelectedProps<T> {
  children(props: {
    value: T[];
    onUnCheck: CKFilterContextProps<T>["onUnCheck"];
  }): ReactElement | ReactElement[];
}

export const CKFilterSelected = <T extends any>({
  children,
}: CKFilterSelectedProps<T>) => {
  const { value, onUnCheck } = useCKFilterContext<T>();
  return <>{children({ value, onUnCheck })}</>;
};
